






























































































































import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  name: 'Overview'
})
export default class extends Vue {
  @Prop() private overviewData!: any
}
